export interface StoryTrailEvent {
  id: string;
  text: string;
}

export interface StoryTrailConfig {
  id: string;
  skillId: string;
  title: string;
  passage: string;
  events: readonly StoryTrailEvent[];
  correctOrder: readonly string[];
  rewardEvent: string;
  hint: string;
  successMessage: string;
}

export function validateStoryTrailConfig(config: StoryTrailConfig) {
  if (config.events.length < 2) {
    throw new RangeError(`Story Trail "${config.id}" needs at least two events.`);
  }

  const eventIds = config.events.map(event => event.id);
  const uniqueIds = new Set(eventIds);
  if (uniqueIds.size !== eventIds.length) {
    throw new Error(`Story Trail "${config.id}" contains duplicate event ids.`);
  }
  if (config.correctOrder.length !== eventIds.length) {
    throw new Error(`Story Trail "${config.id}" must order every event exactly once.`);
  }
  if (config.correctOrder.some(id => !uniqueIds.has(id))
      || new Set(config.correctOrder).size !== uniqueIds.size) {
    throw new Error(`Story Trail "${config.id}" has an invalid correctOrder.`);
  }
}
